module.exports = __webpack_public_path__ + "static/img/20230106_02.5f24752.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230106_02.png
// module id = 3/jw
// module chunks = 0